export default "/images/vendor/flag-icon-css/flags/4x3/tc.svg?f4f865830e706c26ef447d41af35610d";